/* global FB */

import config from '../config'

export {
    FBInit,
    FBLogin,
    FBLogout,
    FBGetAuthQuery,
    FBCheckAuthStatus,
}

function FBInit() {
    FB.init({
        appId: config.FBAppID,
        version: 'v2.10' // use graph api version 2.8
        // cookie: true, // enable cookies to allow the server to access the session
        // xfbml: true, // parse social plugins on this page
    })
}

function FBLogin() {
    return new Promise((resolve, reject) => {
        FB.login(res => {
            if (!res || res.status !== 'connected') {
                return resolve(null)
            }

            // get user info
            FBMe().then(user => {
                return resolve(user)

            }).catch(err => {
                return resolve(null)
            })
        }, {
            scope: 'email'
        })
    })
}

function FBLogout() {
    return new Promise((resolve, reject) => {
        FB.logout(() => {
            return resolve(true)
        })
    })
}

function FBGetAuthQuery() {
    return {
        auth: 'facebook',
        access_token: FB.getAccessToken()
    }
}

function FBCheckAuthStatus(callback) {
    return new Promise((resolve, reject) => {
        FB.getLoginStatus(function (res) {
            if (!res || res.status !== 'connected') {
                return resolve(null)
            }

            return resolve(true)
        })
    })
}

function FBMe(callback) {
    return new Promise((resolve, reject) => {
        FB.api('/me', {
            fields: 'email, name'
        }, function (user) {
            if (!user.email || !user.name) {
                return resolve(null)
            }

            if (!user || !user.id || !user.email || !user.name) {
                return resolve(null)
            }

            return resolve({
                id: user.id,
                name: user.name,
                email: user.email,
            })
        })
    })
}